import './App.css';
import Header from './components/Header';
import Feed from './components/Feed';
import PostUpload from './components/PostUpload';
import Profile from './components/Profile';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import {AuthProvider} from './components/context';


function App() {
    return (
        <AuthProvider>
            <Router>
                <div className="App">
                    <Header />
                    <PostUpload />
                    <Switch>
                        <Route path = '/profile' exact component = {Profile}/>
                        <Route path = '/' exact component = {Feed}/>
                    </Switch>
                </div>
            </Router>
        </AuthProvider>
        
    );
}

export default App;
